/* 🤖 this file was generated by svg-to-ts */
export const iconTriangleLeft = {
    name: 'triangle_left',
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="7 10 5 10" fill="currentColor" width="1em" height="1em"><polygon stroke="none" fill-rule="evenodd" points="7 15 12 20 12 10"/></svg>`,
};
